import { Loader2, Github } from "lucide-react"

export const Icons = {
  spinner: Loader2,
  gitHub: Github,
  google: (props: React.SVGProps<SVGSVGElement>) => (
    <svg role="img" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 10.956v-6.742a4.845 4.845 0 0 1-.748-2.295c0-2.71 2.226-4.97 4.888-4.97a4.943 4.943 0 0 1 3.8 1.874l2.81-2.688A8.687 8.687 0 0 0 12.017 4.01c-4.49 0-8.128 3.623-8.128 8.129a8.127 8.127 0 0 0 8.128 8.129 8.127 8.127 0 0 0 8.128-8.129A8.127 8.127 0 0 0 12.017 0z"
      />
    </svg>
  ),
}